import { render, staticRenderFns } from "./CompanyContactsBtn.vue?vue&type=template&id=1b9d52a6"
import script from "./CompanyContactsBtn.vue?vue&type=script&lang=js"
export * from "./CompanyContactsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports